import * as React from 'react';
import { useContext } from 'react';

import type { ProgramType } from 'bundles/audit/constants';
import type GuidedCourseNextStepsV1 from 'bundles/naptimejs/resources/guidedCourseNextSteps.v1';

export type ProductPrice = { currencyCode: string; amount: number };

export type AuditUpgradeFlowDataContextType = {
  isFreemiumLearner: boolean;
  handleStartFreeTrialClick: () => void;
  productPrice?: ProductPrice;
  programType: ProgramType;
  programName: string;
  hasCompletedFirstModule: boolean;
  loadingHasCompletedFirstModule?: boolean;
  guidedCourseNextSteps?: GuidedCourseNextStepsV1[];
  hasCompletedCourse?: boolean;
  loadingCourseNextSteps?: boolean;
  hasS12nFreeTrial?: boolean;
  courseId: string;
  refetchHasCompletedFirstModule?: () => void;
};

/**
 * @todo remove the export, and migrate the current usage which import this to use useAuditUpgradeFlowData instead
 */
export const AuditUpgradeFlowDataContext = React.createContext<AuditUpgradeFlowDataContextType | null>(null);

/** Custom hook to use the AuditUpgradeFlowDataContext */
export const useAuditUpgradeFlowData = () => useContext(AuditUpgradeFlowDataContext);
